/**
 * 手绘节点 - 点击打开绘画模态框
 */
import React, { memo, useState } from 'react';
import { useReactFlow } from '@xyflow/react';
import { NodeLayout } from './NodeLayout';
import { DrawingModal } from './DrawingModal';
import { useProject } from '../providers/ProjectProvider';
import './DrawingNode.css';

export const DrawingNode = memo(({ id, data }) => {
  const { updateNodeData } = useReactFlow();
  const { readOnly } = useProject();
  const [isModalOpen, setIsModalOpen] = useState(false);

  // 打开绘画模态框
  const handleOpenModal = () => {
    if (!readOnly) {
      setIsModalOpen(true);
    }
  };

  // 保存绘画数据
  const handleSave = (drawingData) => {
    updateNodeData(id, {
      imageUrl: drawingData.imageUrl,
      paths: drawingData.paths,
      textAnnotations: drawingData.textAnnotations,
      hasContent: drawingData.hasContent,
    });
  };

  return (
    <>
      <NodeLayout id={id} type="drawing" title="✏️ 手绘">
        <div 
          className="DrawingNode-wrapper"
          onClick={handleOpenModal}
        >
          {/* 预览区域 */}
          <div className="DrawingNode-preview">
            {data.imageUrl ? (
              <img 
                src={data.imageUrl} 
                alt="手绘预览" 
                className="DrawingNode-preview-image"
              />
            ) : (
              <div className="DrawingNode-placeholder">
                <div className="DrawingNode-placeholder-icon">✏️</div>
                <div className="DrawingNode-placeholder-text">
                  点击开始绘画
                </div>
              </div>
            )}
          </div>

          {/* 状态标识 */}
          <div className="DrawingNode-status">
            {data.hasContent ? (
              <>
                <span className="DrawingNode-status-badge DrawingNode-status-badge-success">
                  ✓ 已绘制
                </span>
                {data.isLocalPreview && (
                  <span className="DrawingNode-status-badge DrawingNode-status-badge-warning">
                    ⚠️ 本地预览
                  </span>
                )}
                {data.fileKey && (
                  <span className="DrawingNode-status-badge DrawingNode-status-badge-info">
                    ☁️ 已上传
                  </span>
                )}
              </>
            ) : (
              <span className="DrawingNode-status-badge DrawingNode-status-badge-empty">
                空白画布
              </span>
            )}
          </div>

          {/* 提示 */}
          {!readOnly && (
            <div className="DrawingNode-hint">
              💡 点击打开画板
            </div>
          )}
        </div>
      </NodeLayout>

      {/* 绘画模态框 */}
      <DrawingModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        initialPaths={data.paths || []}
        initialTextAnnotations={data.textAnnotations || []}
        onSave={handleSave}
        canvasWidth={600}
        canvasHeight={450}
      />
    </>
  );
});

DrawingNode.displayName = 'DrawingNode';
